import * as React from "react";
import { SVGProps } from "react";
const SvgNews = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={24} height={24} rx={4} fill="#095921" />
    <path
      d="M16.667 17.667H7.333A1.333 1.333 0 0 1 6 16.333v-8A1.333 1.333 0 0 1 7.333 7H14a1.333 1.333 0 0 1 1.333 1.333V9m1.334 8.667a1.333 1.333 0 0 1-1.334-1.334V9m1.334 8.667A1.333 1.333 0 0 0 18 16.333v-6A1.334 1.334 0 0 0 16.667 9h-1.334m-2.666-2H10m-1.333 8h4m-4-5.333h4v2.666h-4V9.667Z"
      stroke="#fff"
      strokeWidth={1.13}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgNews;
